// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"McStackedBars_wrapper__ipSnr"};